if (errors.textContent == '') {
    errors.style.display = "none"
} else {
    errors.style.display = "flex"
}
window.onkeydown = function() {
    if (errors.textContent == '') {
        errors.style.display = "none"
    } else {
        errors.style.display = "flex"
    }
    if (count.textContent == '') {
        count.style.display = "none"
    } else {
        count.style.display = "flex"
    }
}
